export default __webpack_public_path__ + "static/hello-890f80b22ba36126589d40df56a0da27.mp4";